import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { CheckBoxField } from './common/fields/CheckBoxField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'replace',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      params: { target: '', replacement: '' },
      transformInPlace: false,
    },
  ],
};

const validationSchema = {
  ...COMMON_VALIDATION,
  'transformations.params.target': {
    required: true,
    validate: (value) => {
      if (!value || value === '') {
        return 'Target character(s) is required';
      }
      return '';
    },
  },
  'transformations.params.replacement': {
    required: true,
    validate: (value) => {
      if (value === null || value === undefined) {
        return 'Replacement character(s) is required';
      }
      return '';
    },
  },
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const handleInPlaceChange = (index, value) => {
    const newTransforms = [...formField.transformations];
    newTransforms[index].transformInPlace = value;
    if (value) {
      newTransforms[index].outputColumn = '';
    }
    setFieldValue('transformations', newTransforms);
  };

  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CheckBoxField
              checked={transform.transformInPlace}
              onChange={(value) => handleInPlaceChange(index, value)}
              disabled={disableForm}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <SourceColumnField
              helperText={
                errors?.sourceColumns ||
                (transform.transformInPlace ? 'This column will be modified directly' : 'Select text column to transform')
              }
              value={transform.sourceColumns?.[0] || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].sourceColumns = [e.target.value];
                setFieldValue('transformations', newTransforms);
              }}
              headers={headers}
              disabled={disableForm}
              error={!!errors.sourceColumns}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.params?.target || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].params = {
                  ...newTransforms[index].params,
                  target: e.target.value,
                };
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              label="Target Character *"
              helperText="Character(s) to replace"
              error={!!errors.params?.target}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.params?.replacement || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].params = {
                  ...newTransforms[index].params,
                  replacement: e.target.value,
                };
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              label="Replacement *"
              helperText="Character(s) to replace with"
              error={!!errors.params?.replacement}
            />
          </Grid>

          {!transform.transformInPlace && (
            <Grid item {...COMMON_STYLES.gridItem}>
              <OutputColumnField
                value={transform.outputColumn}
                onChange={(e) => {
                  const newTransforms = [...formField.transformations];
                  newTransforms[index].outputColumn = e.target.value;
                  setFieldValue('transformations', newTransforms);
                }}
                disabled={disableForm}
                error={!!errors?.outputColumn}
                helperText={errors?.outputColumn || 'Enter output column name'}
              />
            </Grid>
          )}
        </Grid>
      </>
    );
  };

  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title='Replace Text - Swap text segments ("hello", target = "e", replacement = "a" → "hallo")' disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_Replace = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Replace Text"
  />
);

export default NodeModal_Replace;